<template>
  <main class="app-content" v-if="agency">
    <aside class="fixed-sidebar">
      <side-bar :agency="agency"></side-bar>
    </aside>
    <div class="project-layout app-content">
      <template>
        <header class="project-header">
          <h1>{{ agency.displayName }}</h1>
        </header>
      </template>
      <div class="container-fluid">
        <router-link
          :to="'/offices?selectedClient=' + queryParams"
          style="margin-top: 15px"
          v-if="user && user.role !== 'ROLE_AGENT_USER'"
        >
          <button type="button" v-if="true" class="btn btn-quaternary">
            BACK TO {{ agency.client.title }} OFFICES
          </button>
        </router-link>
        <div class="order-media">
          <vue-form
            :state="formState"
            name="propertyCampaignForm"
            @submit.prevent=""
            ref="form"
          >
            <div class="row">
              <div class="col-4">
                <template v-if="selectedProperty !== null">
                  <template v-if="selectedProperty.mainImage">
                    <div class="img-wrapper" v-if="selectedProperty.mainImage">
                      <div
                        class="c__card--image--container c__slider--card"
                        v-if="selectedProperty.mainImage"
                      >
                        <swiper :options="swiperOption">
                          <swiper-slide class="c__card--slide c__slide">
                            <img
                              :src="selectedProperty.mainImage.url"
                              :data-src="selectedProperty.mainImage.url"
                            />
                          </swiper-slide>
                          <template v-if="selectedProperty.images">
                            <swiper-slide
                              v-for="(image, idx) in selectedProperty.images
                                .data"
                              :key="idx"
                              class="c__card--slide c__slide"
                            >
                              <img :src="image.url" :data-src="image.url" />
                            </swiper-slide>
                          </template>
                          <div
                            class="swiper-button-prev"
                            slot="button-prev"
                          ></div>
                          <div
                            class="swiper-button-next"
                            slot="button-next"
                          ></div>
                          <div
                            class="swiper-pagination"
                            slot="pagination"
                          ></div>
                        </swiper>
                      </div>
                    </div>
                    <div class="heading" v-if="selectedProperty.title">
                      <p>
                        <b>Property Address: </b>{{ selectedProperty.title }}
                      </p>
                    </div>
                    <div class="heading" v-if="selectedProperty.displayPrice">
                      <p>
                        <b>Property Price: </b
                        >{{ selectedProperty.displayPrice }}
                      </p>
                    </div>
                    <div class="config" v-if="selectedProperty.beds">
                      <p>
                        <b>Property Config: </b>
                        <span v-if="selectedProperty.beds"
                          >{{ selectedProperty.beds }} BED
                        </span>
                        <span v-if="selectedProperty.baths"
                          >{{ selectedProperty.baths }} BATH
                        </span>
                        <span v-if="selectedProperty.carbays"
                          >{{ selectedProperty.carbays }} CAR BAY</span
                        >
                      </p>
                    </div>
                    <div class="heading" v-if="selectedProperty.saleStatus">
                      <p>
                        <b>Sale Status: </b>{{ selectedProperty.saleStatus }}
                      </p>
                    </div>
                    <div class="description" v-if="selectedProperty.title">
                      <button
                        class="btn-link"
                        v-if="!showDescription"
                        @click="showDescription = true"
                      >
                        Show description
                      </button>
                      <button
                        class="btn-link"
                        v-else
                        @click="showDescription = false"
                      >
                        Hide description
                      </button>
                      <p v-if="showDescription">
                        {{ selectedProperty.description }}
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <div>Note: XML Assets are not currently available</div>
                  </template>
                </template>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label class="small mt-2"
                    >Start typing address if not shown in dropdown</label
                  >
                  <multiselect
                    placeholder="Select or start typing"
                    :value="propertyValue"
                    @select="handlePropertySelect"
                    label="title"
                    track-by="id"
                    name="property"
                    id="property"
                    :options="properties"
                    :searchable="true"
                    :loading="propertiesLoading"
                    :internal-search="false"
                    @search-change="searchProperties"
                    :clear-on-select="false"
                  ></multiselect>
                  <label class="label-with-button"
                    >Select listing for campaign</label
                  >
                </div>
                <div class="o" v-if="importError !== false">
                  {{ importError }}
                </div>
                <template v-if="selectedPackage && selectedProperty">
                  <div class="form-group">
                    <div>{{ selectedPackage.description }}</div>
                    <label>Campaign Description</label>
                  </div>
                </template>
                <template v-if="selectedProperty && showDownloadXml">
                  <div class="form-group">
                    <button
                      type="button"
                      @click="downloadXml"
                      class="btn btn-quaternary"
                    >
                      Download XML
                    </button>
                  </div>
                </template>

                <div class="form-group">
                  <select class="custom-select" v-model="selectedPackage">
                    <option value="null">Select a campaign package</option>
                    <template v-for="product in packages">
                      <option
                        :value="product"
                        :key="product.id"
                        v-if="
                          product.type == 'property' ||
                            product.type == 'agent extend'
                        "
                      >
                        {{ product.title }}
                      </option>
                    </template>
                  </select>
                  <div class="error" v-if="selectedPackageError">
                    Campaign Package is required
                  </div>
                  <label class="label-with-button">select Package</label>
                </div>
                <div
                  class="form-group"
                  v-if="
                    selectedPackage &&
                      selectedProperty &&
                      canAccessAudienceFeatures
                  "
                >
                  <select class="custom-select" v-model="selectedAudience">
                    <option :value="null">Select an audience</option>
                    <template v-for="audience in audiences">
                      <option :value="audience" :key="audience.id">
                        {{ audience.scopeDisplay }} Audience -
                        {{ audience.name }}
                      </option>
                    </template>
                  </select>
                  <label class="label-with-button"
                    >Select Audience (optional)</label
                  >
                </div>
                <template v-if="selectedPackage && selectedProperty">
                  <div class="form-group">
                    <div class="date-time-picker-container">
                      <DateTimePicker
                        color="#13a3eb"
                        class="mr-sm-2"
                        noLabel
                        formatted="DD MMM YYYY"
                        format="YYYY-MM-DD"
                        autoClose
                        input-size="sm"
                        :min-date="tomorrow"
                        v-model="campaign.startDate"
                        noButton
                        noClearButton
                        :no-value-to-custom-elem="false"
                        only-date
                        label="Select date"
                      >
                      </DateTimePicker>
                      <br />
                    </div>
                    <div class="error" v-if="startDateError">
                      Start date is required
                    </div>
                    <label>Campaign start Date</label>
                  </div>
                  <validate
                    class="form-group"
                    v-if="
                      selectedPackage.type == 'property' &&
                        selectedPackage.enablePostcodeTargeting
                    "
                  >
                    <div>
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        v-model="propertyPostCode"
                        @input="handlePropertyPostCodeInput"
                        placeholder=""
                      />
                      <div class="error" v-if="propertyPostCodeError">
                        Invalid format. Each postcode must be up to 4
                        characters, and maximum 4 postcodes allowed
                        (comma-separated).
                      </div>
                    </div>
                    <label class="small"
                      >TO GEO TARGET YOUR CAMPAIGN
                      <span
                        ><br />*PROPERTY POSTCODE AUTOMATICALLY INCLUDED</span
                      ></label
                    >
                    <label>TARGET POSTCODES (1-4) (OPTIONAL) </label>
                  </validate>
                </template>
              </div>
              <div class="col-4" v-if="selectedPackage && selectedProperty">
                <div class="form-group">
                  <div>
                    <textarea
                      class="form-control"
                      v-model="campaign.note"
                      :placeholder="selectedProperty.heading"
                      @focus="onFocusDesc"
                      maxlength="100"
                    ></textarea>
                  </div>
                  <label
                    >Listing Description (short - max 100 characters) - for
                    display on social ads</label
                  >
                </div>
                <div
                  class="form-group"
                  v-if="
                    this.agency.client.clientDisplayConfig.showPropertyUrlField
                  "
                >
                  <div>
                    <input
                      type="url"
                      class="form-control"
                      v-model="campaign.propertyUrl"
                      placeholder="Copy and paste the full property listing URL here including https://"
                    />
                  </div>
                  <div
                    class="error"
                    v-if="
                      formState.$submitted &&
                        campaign.propertyUrl == '' &&
                        this.agency.client.clientDisplayConfig
                          .showPropertyUrlField
                    "
                  >
                    Property URL is required
                  </div>
                  <div
                    class="error"
                    v-if="!validatePropertyUrl() && campaign.propertyUrl"
                  >
                    Property URL is not valid
                  </div>
                  <label>Listing Page URL</label>
                </div>
                <div class="form-group" v-if="selectedPackage.videoRequired">
                  <div class="row" style="margin-top: 10px">
                    <div class="col-4">
                      <video-upload
                        :video="video"
                        :displayLabel="false"
                        :handleFileChange="handleVideoFileChange"
                        ref="videoRef"
                      />
                    </div>
                  </div>
                  <div
                    v-if="videoSizeError"
                    style="color: red;font-size: 14px;"
                  >
                    {{ VIDEO_ERROR_MESSAGES.MAX_SIZE }}
                  </div>
                  <div
                    v-if="videoFileTypeError"
                    style="color: red;font-size: 14px;"
                  >
                    {{ VIDEO_ERROR_MESSAGES.FILE_TYPE }}
                  </div>
                  <div v-if="videoError" style="color: red;font-size: 14px;">
                    {{ VIDEO_ERROR_MESSAGES.REQUIRED }}
                  </div>
                  <label
                    >Video<span style="font-size: 12px;"
                      ><br />MP4 only max 1GB</span
                    ></label
                  >
                </div>

                <div
                  class="form-group"
                  v-if="selectedPackage.type == 'property' && agentName"
                >
                  <div class="col-4" style="padding: 0">{{ agentName }}</div>
                  <label class="mt-2">Lead Agent Name</label>
                </div>

                <div
                  class="form-group"
                  v-if="selectedPackage.type == 'property'"
                >
                  <div class="col-4" style="padding: 0; margin-top: 10px">
                    <logo-upload
                      :logo="campaign.mainImage"
                      name="mainImage"
                      :displayLabel="false"
                      ref="mainImageRef"
                      v-if="renderComponent"
                      v-on:logoupload="mainImageUpdated = true"
                      :showCheckerboard="false"
                    />
                  </div>
                  <div class="error" v-if="mainImageSizeError">
                    Lead Agent Image must be 1MB Max Size
                  </div>
                  <div class="error" v-if="mainImageError">
                    Lead Agent Image is required
                  </div>
                  <label class="small"
                    >REA Standard Headshot .jpg or .png MAX size 1MB</label
                  >
                  <label>Lead Agent Image</label>
                </div>

                <div
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <select
                    class="custom-select"
                    v-model="agentId"
                    @change="handleUserChange($event)"
                  >
                    <option value="null">Select Agent</option>
                    <template v-for="user in users">
                      <option :key="user.id" :value="user.id">
                        {{ user.firstName + ' ' + user.lastName }}
                      </option>
                    </template>
                  </select>
                  <label class="label-with-button">Lead Agent</label>
                </div>
                <validate
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="agentCampaign.name"
                      placeholder=""
                      required
                    />
                    <field-messages name="name" show="$dirty && $invalid">
                      <div class="error" slot="required">
                        Lead Agent name is required
                      </div>
                    </field-messages>
                  </div>
                  <label class="small"
                    >This will display on all ad creative. Format: First
                    Last</label
                  >
                  <label>Lead Agent Name *</label>
                </validate>
                <validate
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <div>
                    <input
                      type="email"
                      class="form-control"
                      name="email"
                      v-model="agentCampaign.email"
                      placeholder="Please enter a valid email"
                      required
                    />
                    <field-messages name="email" show="$dirty && $invalid">
                      <div class="error" slot="required">
                        Lead Agent Email Address is required
                      </div>
                      <div class="error" slot="email">Email is not valid</div>
                    </field-messages>
                  </div>
                  <label class="small"
                    >This won't display on the display creative. An agent email
                    address is required for the agent to receive the media order
                    confirmation.</label
                  >
                  <label>Lead Agent Email *</label>
                </validate>
                <div
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <div class="col-4" style="padding: 0; margin-top: 10px">
                    <logo-upload
                      :logo="agentCampaign.mainImage"
                      name="mainImage"
                      :displayLabel="false"
                      ref="mainImageRef"
                      v-if="renderComponent"
                      v-on:logoupload="mainImageUpdated = true"
                      :showCheckerboard="false"
                    />
                  </div>
                  <div class="error" v-if="mainImageSizeError">
                    Lead Agent Image must be 1MB Max Size
                  </div>
                  <div class="error" v-if="mainImageError">
                    Lead Agent Image is required
                  </div>
                  <label class="small"
                    >REA Standard Headshot .jpg or .png MAX size 1MB</label
                  >
                  <label>Lead Agent Image *</label>
                </div>
                <validate
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      name="phone"
                      v-model="agentCampaign.phone"
                      placeholder=""
                      required
                      @change="phoneChanged = true"
                    />
                    <field-messages name="phone" show="$dirty && $invalid">
                      <div class="error" slot="required">
                        Lead Agent Phone Number is required
                      </div>
                    </field-messages>
                  </div>
                  <label class="small"
                    >This will display on all ad creative. Format: 0000 111 222
                    (do not include +61)</label
                  >
                  <label>Lead Agent Phone Number *</label>
                </validate>
                <validate
                  class="form-group"
                  v-if="selectedPackage.type == 'agent extend'"
                >
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="agentCampaign.postcode"
                      placeholder=""
                      required
                      minlength="4"
                    />
                    <div class="error" v-if="postcodeError">
                      Postcode is required with exactly 1 postcode.
                    </div>
                  </div>
                  <label class="small"
                    >To Geotarget the Agent Extend Campaign</label
                  >
                  <label>Agent Extend: Lead Agent Target Postcode *</label>
                </validate>
                <validate
                  class="form-group"
                  v-if="
                    selectedPackage.type == 'agent extend' &&
                      selectedPackage.enablePostcodeTargeting
                  "
                >
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="propertyPostCode"
                      @input="handlePropertyPostCodeInput"
                      placeholder=""
                    />
                    <div class="error" v-if="propertyPostCodeError">
                      Invalid format. Each postcode must be up to 4 characters,
                      and maximum 4 postcodes allowed (comma-separated).
                    </div>
                  </div>
                  <label class="small"
                    >TO GEO TARGET YOUR CAMPAIGN
                    <span
                      ><br />*PROPERTY POSTCODE AUTOMATICALLY INCLUDED</span
                    ></label
                  >
                  <label>TARGET POSTCODES (1-4) (OPTIONAL)</label>
                </validate>

                <div
                  class="form-group mb-3"
                  v-if="
                    showAgentPageUrl && selectedPackage.type === 'agent extend'
                  "
                >
                  <div>
                    <div class="d-flex mb-1">
                      <div class="mr-3 d-flex align-items-center">
                        <input
                          type="radio"
                          name="url-source"
                          id="property-url-source"
                          v-model="urlSource"
                          value="property"
                          style="display: inline;"
                        />
                        <label
                          for="property-url-source"
                          class="ml-1"
                          style="margin-bottom: -1px;"
                          >Property URL</label
                        >
                      </div>
                      <div class="mr-3 d-flex align-items-center">
                        <input
                          type="radio"
                          name="url-source"
                          id="agent-url-source"
                          v-model="urlSource"
                          value="agent"
                          style="display: inline;"
                        />
                        <label
                          for="agent-url-source"
                          class="ml-1"
                          style="margin-bottom: -1px;"
                          >Agent URL</label
                        >
                      </div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      v-model="url"
                      placeholder="Copy and paste the the full agent URL here including https://"
                      required
                      minlength="4"
                      :disabled="urlSource === 'property'"
                    />
                    <div
                      style="color: #f77263; font-size: 0.83125rem"
                      v-if="agentUrlError"
                    >
                      Error: Agent Page URL supplied is not housed within your
                      agency's website
                    </div>
                  </div>
                  <label class="small"
                    >THE DESTINATION URL OF THE AGENT EXTEND CAMPAIGN</label
                  >
                  <label>Agent Extend: AGENT PAGE DESTINATION URL *</label>
                </div>

                <div>
                  <div>
                    <label class="bold">Additional Report Recipients </label>
                    <br />
                    <label class="small"
                      >ADD ADDITIONAL RECIPIENTS FOR THE CAMPAIGN REPORTS</label
                    >
                    <br />
                    <div
                      class="mb-1"
                      v-for="(recipient, index) in recipientLists"
                      :key="'recipient' + index"
                    >
                      <validate>
                        <input
                          class="form-control inline no-m-l"
                          type="email"
                          v-model="recipientLists[index]"
                          :name="'recipient' + index"
                          required
                        />
                        <button
                          type="button"
                          class="btn-remove"
                          @click="removeRecipient(index)"
                        >
                          &times;
                        </button>
                        <field-messages
                          :name="'recipient' + index"
                          show="$dirty && $invalid"
                        >
                          <div class="error" slot="required">
                            Email is required otherwise remove this field
                          </div>
                          <div class="error" slot="email">
                            Email is not valid
                          </div>
                        </field-messages>
                      </validate>
                    </div>
                    <div class="space-between">
                      <button class="btn-link mt-1 mb-2" @click="addRecipient">
                        Add recipient
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <div class="space-between">
                    <div></div>
                    <div>
                      <div class="text-right">
                        Package Fee:
                        <span class="bold">{{
                          selectedPackage.packagePrice | formatCurrency
                        }}</span>
                      </div>
                      <div class="text-right bold" v-if="agency.includeGst">
                        GST 10% Tax:
                        <span>{{
                          (selectedPackage.packagePrice * 0.1) | formatCurrency
                        }}</span>
                      </div>
                      <div class="text-right bold">
                        Total <span v-if="agency.includeGst">(incl. GST)</span
                        ><span v-else>(excl. GST)</span>:
                        <span>{{
                          formatTotalPrice(selectedPackage) | formatCurrency
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-if="agency.organicCampaigns">
                  <div class="space-between">
                    <div></div>
                    <div class="c__checkbox">
                      <input type="checkbox" v-model="campaign.organicPost" />
                      <label v-if="selectedPackage.type == 'property'"
                        >Include Organic Social Post</label
                      >
                      <label v-else
                        >Include Organic Social Post (property only)</label
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="space-between">
                    <div>
                      <div class="c__btn--container">
                        <button
                          class="btn btn-quaternary"
                          @click="openCreativeModal"
                        >
                          Preview Ad Creative
                        </button>
                      </div>
                    </div>
                    <div>
                      <div class="c__btn--container">
                        <button
                          class="btn btn-primary"
                          @click="openModal"
                          type="submit"
                          :disabled="formState.$invalid || disableSubmit"
                        >
                          Confirm and pay
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-form>
        </div>
      </div>
      <result-message :errors="errors"></result-message>
      <transition name="modal">
        <order-media-modal
          :campaign="campaign"
          :campaign-id="campaignId"
          :extend-campaign-id="agentCampaignId"
          :agency="agency"
          :property="selectedProperty"
          :_package="selectedPackage"
          :total="selectedPackage.packagePrice * 1.1"
          :start-date="campaign.startDate"
          v-if="showModal"
          @closeModal="closeModal"
          @closeModalAndCleanCampaign="closeModalAndCleanCampaign"
        ></order-media-modal>
      </transition>

      <transition name="modal">
        <creative-modal
          v-if="showCreativeModal"
          :propertyId="selectedProperty.id"
          :campaign="campaign"
          :extendCampaign="agentCampaign"
          :closeModal="closeCreativeModal"
          :logoUrl="officeLogoPreviewUrl"
        ></creative-modal>
      </transition>
      <app-modal-progress-bar
        :state="videoUploadProgress.state"
        :progress="videoUploadProgress.progress"
        :label="videoUploadProgress.label"
        :onCancel="onCancelVideoUpload"
        v-if="videoUploadProgress.visible"
      ></app-modal-progress-bar>
    </div>
  </main>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import SideBar from '../SideBar';

import {SwiperOptions} from '../../../configs/Swiper';
import 'swiper/dist/css/swiper.css';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import Multiselect from 'vue-multiselect';

import DateTimePicker from 'vue-ctk-date-time-picker';
import ResultMessage from '../../../helpers/ResultMessage';
import VideoUpload from '../../../helpers/VideoUpload';

import PropertyService from '../../../services/properties';
import AgencyService from '../../../services/agencies';
import CampaignService from '../../../services/campaigns';
import FileService from '../../../services/files';

import OrderMediaModal from '../OrderMediaModal';
import CreativeModal from '../CreativeModal';
import LogoUpload from '../../../helpers/LogoUpload';
import UserServices from '../../../services/users';
import Navigation from '../../../configs/Perimeters/navigation';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import URLHelpers from '../../../helpers/URLHelpers';
import {VIDEO_ERROR_MESSAGES, VIDEO_LIMITS} from '../../../configs/videoLimits';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';

export default {
  components: {
    SideBar,
    swiper,
    swiperSlide,
    ResultMessage,
    OrderMediaModal,
    DateTimePicker,
    VideoUpload,
    CreativeModal,
    Multiselect,
    LogoUpload,
    AppModalProgressBar,
  },
  data() {
    return {
      user: null,
      agency: null,
      tomorrow: null,
      swiperOption: SwiperOptions,
      campaignId: null,
      agentCampaignId: null,
      showDescription: false,
      showModal: false,
      properties: [],
      propertiesLoading: false,
      propertySearchTimeout: null,
      agencyPackages: null,
      clientPackages: null,
      showDownloadXml: false,
      hasAdminAccess: false,
      packages: null,
      campaign: {
        note: '',
        mainImage: {},
        additionalRecipients: '',
        propertyUrl: '',
      },
      propertyPostCode: '',
      agentCampaign: {
        type: '',
        name: '',
        email: '',
        phone: '',
        mainImage: {},
        additionalRecipients: '',
        postcode: '',
        startDate: null,
        destinationUrl: '',
      },
      agentId: null,
      agentName: null,
      videoError: false,
      videoSizeError: false,
      videoFileTypeError: false,
      videoDurationError: false,
      videoResolutionError: false,
      selectedProperty: null,
      selectedPackage: null,
      selectedPackageError: false,
      startDateError: false,
      selectedAgency: null,
      selectedAudience: null,
      importError: false,
      errors: {
        type: Object | Error,
        $clean: true,
      },
      formState: {},
      showCreativeModal: false,
      mainImageError: false,
      mainImageSizeError: false,
      mainImageUpdated: false,
      mainImageTempLocation: '',
      renderComponent: true,
      selectedUserId: null,
      phoneChanged: false,
      agentImageUpdated: false,
      recipientLists: [],
      disableSubmit: false,
      audiences: [],
      postcodeError: false,
      propertyPostCodeError: false,
      agentUrlError: false,
      showAgentPageUrl: false,
      urlSource: 'property',
      url: '',
      VIDEO_ERROR_MESSAGES: VIDEO_ERROR_MESSAGES,
      VIDEO_LIMITS: VIDEO_LIMITS,
      video: null,
      videoUploadProgress: {
        progress: 0,
        visible: false,
        label: 'Uploading your video, please wait...',
        state: 'loading',
      },
      videoUploadController: null,
    };
  },
  methods: {
    formatTotalPrice(selectedPackage) {
      const price = this.agency.includeGst
        ? selectedPackage.packagePrice * 1.1
        : selectedPackage.packagePrice;

      return price;
    },
    handleUserChange(event) {
      this.$nextTick(() => {
        const id = event.target.value;
        this.selectedUserId = id;
        this.userChange(id);
      });
    },
    propertyUserChange(id) {
      if (
        this.selectedProperty.propertyUsers &&
        this.selectedProperty.propertyUsers.data &&
        this.selectedProperty.propertyUsers.data.length
      ) {
        let userData = this.selectedProperty.propertyUsers.data.find(
          (userData) => userData.user.id == id
        );
        if (userData) {
          let user = userData.user;
          this.campaign.mainImage = user.imageOriginal;
          this.selectedUserId = userData.user.id;
          // Populate all agent campaign relevant fields
          this.userChange(userData.user.id);
        }
      }
    },
    userChange(id) {
      let user = this.users.find((user) => user.id == id);

      this.agentCampaign.name = user.firstName + ' ' + user.lastName;
      this.agentCampaign.email = user.email;
      this.agentCampaign.phone = user.mobile;
      this.agentCampaign.mainImage = user.imageOriginal;

      if (user.postcode) {
        this.agentCampaign.postcode = user.postcode.substring(0, 4);
      }

      if (user.imageOriginal) {
        this.$refs.mainImageRef.newLogo = null;
        this.$refs.mainImageRef.uploadFile.size = 1;
      }
      this.uploadTemporaryFile();
      this.formState.name.$dirty = true;
      this.formState.email.$dirty = true;
      this.formState.phone.$dirty = true;
    },
    uploadTemporaryFile() {
      let formData = null;
      formData = new FormData();
      let imageType = null;
      if (this.mainImageUpdated) {
        if (
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          formData.append('image', this.$refs.mainImageRef.uploadFile);
        }
        this.mainImageUpdated = false;
        this.agentImageUpdated = true;
        imageType = 'agent';
      }
      if (imageType) {
        FileService.uploadTempFile(formData)
          .then((response) => {
            if (imageType == 'agent') {
              this.mainImageTempLocation = response;
            }
            this.validateMainImage();
          })
          .catch((errors) => {});
      }
    },
    validateMainImage() {
      if (this.selectedPackage.type == 'agent extend') {
        if (
          this.agentCampaign.mainImage &&
          (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
        ) {
          // Image provided against agent selection
          this.mainImageError = false;
        } else if (
          !this.$refs.mainImageRef ||
          typeof this.$refs.mainImageRef.uploadFile.size === 'undefined'
        ) {
          // No image provided
          this.mainImageError = true;
        } else {
          // Image uploaded against agent image field
          this.mainImageError = false;
          if (this.$refs.mainImageRef.uploadFile.size > 1024000) {
            this.mainImageSizeError = true;
          } else {
            this.mainImageSizeError = false;
          }
        }
      }
      if (this.selectedPackage.type == 'property') {
        this.mainImageError = false;
        if (this.$refs.mainImageRef.uploadFile.size > 1024000) {
          this.mainImageSizeError = true;
        } else {
          this.mainImageSizeError = false;
        }
      }
    },
    checkUserPermissions(property) {
      const isAdmin = Navigation.isSuperAdmin() || Navigation.isAdmin();
      this.hasAdminAccess = isAdmin;
      if (typeof property.thirdPartyData === 'undefined') {
        return (this.showDownloadXml = false);
      }
      this.showDownloadXml = isAdmin;
    },
    downloadXml() {
      if (this.selectedProperty.thirdPartyData) {
        const data = JSON.parse(this.selectedProperty.thirdPartyData);
        const beautifiedData = JSON.stringify(data, null, 2);
        const blob = new Blob([beautifiedData], {type: 'application/json'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.selectedProperty.id}-xml.json`);
        document.body.appendChild(link);
        link.click();
      }
    },

    validatePackage() {
      if (!this.selectedPackage) {
        this.selectedPackageError = true;
      } else {
        this.selectedPackageError = false;
      }
    },
    validateStartDate() {
      if (!this.campaign.startDate) {
        this.startDateError = true;
      } else {
        this.startDateError = false;
      }
    },
    validateVideo() {
      let hasError = false;
      // Reset all video errors
      this.videoError = false;
      this.videoFileTypeError = false;
      this.videoSizeError = false;

      // Check if video is required
      if (!this.selectedPackage || !this.selectedPackage.videoRequired) {
        return true;
      }

      // Check if it's a File instance
      if (this.video instanceof File) {
        // Check file size
        if (this.video.size > VIDEO_LIMITS.MAX_SIZE) {
          hasError = true;
          this.videoSizeError = true;
        }

        // Check file type
        const isValidType =
          this.video.type === 'video/mp4' &&
          this.video.name.toLowerCase().endsWith('.mp4');

        if (!isValidType) {
          hasError = true;
          this.videoFileTypeError = true;
        }

        return !hasError;
      } else {
        this.videoError = true;
        return false;
      }
    },
    validatePropertyUrl() {
      if (!this.campaign.propertyUrl || this.campaign.propertyUrl == '') {
        return false;
      }

      const blockedDomains = [
        'realestate.com.au',
        'domain.com.au',
        'homely.com.au',
        'ratemyagent.com.au',
        'propertymate.com.au',
      ];

      const urlLower = this.url.toLowerCase();
      for (const domain of blockedDomains) {
        if (
          urlLower.includes(`.${domain}`) ||
          urlLower.includes(`https://${domain}`) ||
          urlLower.includes(`https://www.${domain}`)
        ) {
          this.agentUrlError = true;
          return false;
        }
      }

      const urlPattern = new RegExp(
        '^https:\\/\\/' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?' +
        '(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=\\/-]*)?' + // Added \/ to allow forward slashes
          '(\\#[-a-z\\d_]*)?$',
        'i'
      );

      return !!urlPattern.test(this.campaign.propertyUrl);
    },
    validateAgentPostcode() {
      if (this.selectedPackage.type !== 'agent extend') return true;
      if (!this.agentCampaign.postcode) {
        this.postcodeError = true;
        return false;
      }

      const postcodes = this.agentCampaign.postcode.split(',');
      if (postcodes.length > 1) {
        this.postcodeError = true;
        return false;
      }

      return true;
    },
    validateAgentUrl() {
      // Automatically pass if it isn't an agent extend package
      if (this.selectedPackage.type !== 'agent extend') return true;
      // Automatically pass if the show agent page url isn't turned on
      if (!this.showAgentPageUrl) return true;

      if (!this.url) {
        this.agentUrlError = true;
        return false;
      }

      if (!URLHelpers.isValidUrl(this.url)) {
        this.agentUrlError = true;
        return false;
      }

      const blockedDomains = [
        'realestate.com.au',
        'domain.com.au',
        'homely.com.au',
        'ratemyagent.com.au',
        'propertymate.com.au',
      ];

      const urlLower = this.url.toLowerCase();
      for (const domain of blockedDomains) {
        if (
          urlLower.includes(`.${domain}`) || // Check subdomain
          urlLower.includes(`https://${domain}`) || // Check top-level domain
          urlLower.includes(`https://www.${domain}`) // Check www subdomain
        ) {
          this.agentUrlError = true;
          return false;
        }
      }

      if (
        this.agency &&
        this.agency.client &&
        this.agency.client.clientDomains
      ) {
        const domains = this.agency.client.clientDomains
          .split(',')
          .map((clientDomain) => clientDomain.replace(/\s/, ''));
        if (!URLHelpers.isWhiteListedDomain(this.url, domains)) {
          this.agentUrlError = true;
          return false;
        }
      }

      return true;
    },
    handlePropertyPostCodeInput(event) {
      let value = event.target.value;

      value = value.replace(/[^a-zA-Z0-9,\s]/g, '');

      let parts = value.split(',').map((part) => part.trim());

      if (parts.length > 4) {
        parts = parts.slice(0, 4);
      }

      const processedParts = parts.map((part) => part.substring(0, 4));

      const lastPart = processedParts[processedParts.length - 1] || '';
      const isLastPartComplete = lastPart.length === 4;
      const canAddMorePostcodes = processedParts.length < 4;

      let formattedValue = processedParts.join(', ');

      if (
        isLastPartComplete &&
        canAddMorePostcodes &&
        !value.endsWith(',') &&
        !value.endsWith(', ')
      ) {
        formattedValue += ', ';
      }

      this.propertyPostCode = formattedValue;

      this.validatePropertyPostCode();
    },
    validatePropertyPostCode() {
      if (!this.propertyPostCode || this.propertyPostCode.trim() === '') {
        this.propertyPostCodeError = false;
        return true;
      }

      // Split by comma and filter out empty strings
      const postcodes = this.propertyPostCode
        .split(',')
        .map((p) => p.trim())
        .filter((p) => p.length > 0);

      // Check if more than 4 postcodes
      if (postcodes.length > 4) {
        this.propertyPostCodeError = true;
        return false;
      }

      // Check if any postcode is longer than 4 characters
      for (const postcode of postcodes) {
        if (postcode.length > 4) {
          this.propertyPostCodeError = true;
          return false;
        }
      }

      this.propertyPostCodeError = false;
      return true;
    },
    validate() {
      this.agentUrlError = false;
      this.postcodeError = false;
      this.propertyPostCodeError = false;
      this.validatePackage();
      this.validateStartDate();
      this.validateMainImage();
      const validAgentPostcode = this.validateAgentPostcode();
      const validAgentUrl = this.validateAgentUrl();
      const validPropertyPostCode = this.validatePropertyPostCode();

      if (
        (this.selectedPackageError ||
          this.startDateError ||
          this.videoError ||
          this.mainImageError ||
          this.mainImageSizeError ||
          (this.agency.client.clientDisplayConfig.showPropertyUrlField &&
            !this.validatePropertyUrl()) ||
          (this.campaign.propertyUrl && !this.validatePropertyUrl()) ||
          !validAgentPostcode ||
          !validAgentUrl ||
          !validPropertyPostCode,
        !this.validateVideo())
      ) {
        return false;
      }

      return true;
    },
    async openModal() {
      if (!this.validate()) {
        return;
      }

      event.preventDefault();
      this.disableSubmit = true;

      this.campaign.shortDesc =
        this.campaign.note === ''
          ? this.selectedProperty.heading
          : this.campaign.note;
      this.campaign.property = this.selectedProperty.id;
      this.campaign.package = this.selectedPackage.id;
      this.campaign.agency = this.selectedAgency.id;
      this.campaign.audience = this.selectedAudience
        ? this.selectedAudience.id
        : null;
      this.campaign.additionalRecipients = this.recipientLists.toString();

      if (this.selectedPackage.type === 'agent extend') {
        this.campaign.name = this.agentCampaign.name;
        this.campaign.email = this.agentCampaign.email;
        this.campaign.phone = this.agentCampaign.phone;
        this.campaign.postcode = this.agentCampaign.postcode;
        this.campaign.destinationUrl =
          this.urlSource === 'agent' ? this.url : null;
      }

      if (!this.campaign.startDate) {
        this.campaign.startDate = this.tomorrow;
      }

      if (this.selectedAgency.propertyCampaignPaymentOption) {
        this.campaign.paymentOption = this.selectedAgency.propertyCampaignPaymentOption;
      } else {
        this.campaign.paymentOption = this.selectedAgency.client.propertyCampaignPaymentOption;
      }

      if (this.selectedPackage.type == 'property') {
        this.campaign.type = 'property';
      } else if (this.selectedPackage.type == 'agent extend') {
        this.campaign.type = 'property extend';
      }

      // drop mainImage key to not send invalid image object
      // Vue.delete(this.campaign, 'mainImage');

      if (
        this.campaign.mainImage &&
        typeof this.campaign.mainImage.id !== 'undefined' &&
        (!this.$refs.mainImageRef || !this.$refs.mainImageRef.newLogo)
      ) {
        // Send existing mainImage ID
        if (this.selectedPackage.type === 'agent extend') {
          this.campaign.mainImage = this.agentCampaign.mainImage.id;
        } else {
          this.campaign.mainImage = this.campaign.mainImage.id;
        }
      } else if (
        this.$refs.mainImageRef &&
        typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined' &&
        this.$refs.mainImageRef.uploadFile.size > 1
      ) {
        let formData = new FormData();
        formData.append('image', this.$refs.mainImageRef.uploadFile);
        formData.append('subType', 'agent-image');
        await FileService.uploadFile(formData)
          .then((image) => {
            this.campaign.mainImage = image.id;
          })
          .catch((errors) => {
            this.errors = errors;
            return;
          });
      } else if (
        this.selectedPackage.type === 'agent extend' &&
        this.$refs.mainImageRef
      ) {
        this.campaign.mainImage = this.agentCampaign.mainImage.id;
      }

      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      this.campaign.propertyPostCode = this.propertyPostCode;

      await CampaignService.createCampaign(this.campaign)
        .then((campaign) => {
          if (campaign && campaign.id) {
            this.campaignId = campaign.id;
          }
        })
        .catch((errors) => {
          this.errors = errors;
          return;
        });

      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      // Ends here

      if (!this.errors.$clean) {
        this.disableSubmit = false;
        return;
      }

      if (this.selectedPackage.type == 'agent extend') {
        if (this.selectedUserId && this.selectedUserId != 'null') {
          this.userUpdate();
        }
      } else {
        if (this.agentImageUpdated) {
          this.userUpdate();
        }
      }

      this.showModal = true;
    },
    async userUpdate() {
      if (this.phoneChanged || this.agentImageUpdated) {
        let user;
        if (this.selectedPackage.type == 'property') {
          if (
            this.selectedProperty.propertyUsers &&
            this.selectedProperty.propertyUsers.data &&
            this.selectedProperty.propertyUsers.data.length
          ) {
            user = this.selectedProperty.propertyUsers.data[0].user;
          } else {
            return;
          }
        } else {
          user = this.users.find((findUser) => {
            return findUser.id == this.selectedUserId;
          });
        }

        if (!user) {
          return;
        }

        if (this.phoneChanged) {
          user.mobile = this.agentCampaign.phone;
        }

        if (this.agentImageUpdated) {
          let formData = null;
          if (
            this.$refs.mainImageRef &&
            typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
          ) {
            formData = new FormData();
            formData.append('image', this.$refs.mainImageRef.uploadFile);
            formData.append('subType', 'agent original');
          }

          if (formData) {
            await FileService.uploadFile(formData)
              .then((mainImageRef) => {
                user.imageOriginal = mainImageRef.id;
              })
              .catch((errors) => {
                this.errors = errors;
              });
          }
        } else {
          user.imageOriginal = user.imageOriginal.id;
        }

        user.role = user.role.value;

        UserServices.updateUser(user);
      }
    },
    closeModal() {
      this.showModal = false;
      this.disableSubmit = false;
    },
    closeModalAndCleanCampaign() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
        this.campaign = {
          note: '',
          mainImage: {},
          additionalRecipients: '',
        };
        this.agentCampaign = {
          type: '',
          name: '',
          email: '',
          phone: '',
          mainImage: {},
          additionalRecipients: '',
          postcode: '',
        };
        this.selectedProperty = null;
        this.selectedPackage = null;
        this.getProperties();
        this.$refs.form.reset();
      });
      this.showModal = false;
      this.disableSubmit = false;
    },
    onCancelVideoUpload() {
      // Cancel the ongoing API request
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null; // Clear immediately
      }
      this.videoUploadProgress.visible = false;
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      this.video = null;
      this.campaign.videoId = null;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.clearVideo();
      }
    },
    handlePropertySelect(data) {
      this.selectedProperty = data;
      this.checkUserPermissions(data);
      PropertyService.getProperty(data.id, 'images,propertyUsers').then(
        (property) => {
          this.selectedProperty = property;
          if (
            this.selectedProperty.propertyUsers &&
            this.selectedProperty.propertyUsers.data &&
            this.selectedProperty.propertyUsers.data.length
          ) {
            this.agentId = this.selectedProperty.propertyUsers.data[0].user.id;
            this.agentName =
              this.selectedProperty.propertyUsers.data[0].user.firstName +
              ' ' +
              this.selectedProperty.propertyUsers.data[0].user.lastName;
            this.propertyUserChange(this.agentId);
          } else {
            this.agentName = null;
          }
        }
      );
      this.importError = false;
      this.campaign.note = '';
      this.campaign.mainImage = {};
      this.agentCampaign.mainImage = {};
    },
    getProperties() {
      PropertyService.setAgency(this.selectedAgency)
        .getProperties('', 'mainImage,slug')
        .then((properties) => {
          this.properties = properties.data;
          this.properties.forEach((property) => {
            property.$isDisabled = !property.isOrderable;
          });
        });
    },
    searchProperties(query) {
      clearTimeout(this.propertySearchTimeout);
      this.propertySearchTimeout = setTimeout(() => {
        if (query) {
          this.propertiesLoading = true;
          PropertyService.setAgency(this.selectedAgency)
            .getProperties('', 'mainImage,slug', query)
            .then((properties) => {
              this.properties = properties.data;
              this.properties.forEach((property) => {
                property.$isDisabled = !property.isOrderable;
              });
              this.propertiesLoading = false;
            })
            .catch((error) => {
              this.propertiesLoading = false;
            });
        } else if (!this.selectedProperty) {
          this.getProperties();
        }
      }, 1000);
    },
    getAgency() {
      AgencyService.getAgency(
        this.$route.params.agency,
        'address,automateReport,client,permissions,ordersReport'
      ).then((agency) => {
        this.agency = agency;

        if (
          this.agency &&
          this.agency.client &&
          this.agency.client.clientDisplayConfig
        ) {
          this.showAgentPageUrl = this.agency.client.clientDisplayConfig.showAgentLandingPage;
        }

        this.selectedAgency = agency;
        this.agencyPackages = agency.packages ? agency.packages.data : [];
        this.clientPackages = agency.client.packages
          ? agency.client.packages.data
          : [];
        this.packages = [...this.agencyPackages, ...this.clientPackages];
        this.packages = Array.from(new Set(this.packages.map((a) => a.id))).map(
          (id) => {
            return this.packages.find((a) => a.id === id);
          }
        );
        this.packages = this.packages.filter(
          (pack) => pack.status == 'published'
        );
        this.packages.sort((a, b) =>
          a.sortOrder > b.sortOrder ? 1 : b.sortOrder > a.sortOrder ? -1 : 0
        );
        this.users = agency.permissions
          ? agency.permissions.data.map((a) => a.user)
          : [];
        agency.client.clientAdmins
          ? (this.users = this.users.concat(agency.client.clientAdmins.data))
          : null;
        this.users.sort((a, b) =>
          a.firstName.toLowerCase() + a.lastName.toLowerCase() >
          b.firstName.toLowerCase() + b.lastName.toLowerCase()
            ? 1
            : b.firstName.toLowerCase() + b.lastName.toLowerCase() >
              a.firstName.toLowerCase() + a.lastName.toLowerCase()
            ? -1
            : 0
        );
        this.getProperties();
      });
    },
    onFocusDesc() {
      if (this.campaign.note === '') {
        this.campaign.note = this.selectedProperty.heading;
      }
    },
    openCreativeModal() {
      if (this.selectedProperty) {
        this.agentCampaign.mainImageTempLocation = this.mainImageTempLocation;
        this.agentCampaign.campaignType = this.selectedPackage.type;
        this.showCreativeModal = true;
      }
    },
    closeCreativeModal() {
      this.showCreativeModal = false;
    },
    addRecipient() {
      this.recipientLists.push('');
    },
    removeRecipient(index) {
      this.recipientLists.splice(index, 1);
    },
    async handleVideoFileChange(file) {
      // Clear any existing controller first
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }

      this.videoUploadController = new AbortController();

      this.video = file;
      const isValid = this.validateVideo();

      if (!isValid) {
        this.videoUploadController = null;
        return;
      }

      this.videoError = false;
      this.videoFileTypeError = false;
      this.videoSizeError = false;
      this.videoUploadProgress.visible = true;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      try {
        const presignedData = await CampaignServiceV2.getUploadPresignedUrl(
          file.name
        );

        const onProgress = (progress) => {
          if (progress < 95) {
            this.videoUploadProgress.progress = progress;
          }
        };
        await CampaignServiceV2.uploadBinaryToPresignedUrl(
          presignedData.data.url,
          file,
          onProgress,
          this.videoUploadController
        );

        const registeredVideo = await CampaignServiceV2.registerVideo({
          filename: presignedData.data.filename,
        });

        this.campaign.videoId = registeredVideo.data.id;
        this.videoError = false;

        this.videoUploadProgress.progress = 100;
        this.videoUploadProgress.state = 'loaded';
        this.videoUploadProgress.label = 'Video upload successful.';
      } catch (error) {
        // Handle abort specifically - for axios 0.18.0 cancellation
        if (
          error.name === 'AbortError' ||
          error.message.includes('aborted') ||
          error.code === 'ERR_CANCELED' ||
          axios.isCancel(error) ||
          error.message.includes('cancelled') ||
          error.message === 'Upload cancelled by user'
        ) {
          this.videoUploadProgress.state = 'cancelled';
          this.videoUploadProgress.label = 'Video upload cancelled.';
          // Don't clear video on cancel, just hide progress
          setTimeout(() => {
            this.videoUploadProgress.visible = false;
          }, 1000);
          return;
        }

        // Handle other errors
        this.video = null;
        this.campaign.videoId = null;
        this.$refs.videoRef.clearVideo();
        this.videoUploadProgress.state = 'error';
        this.videoUploadProgress.label =
          'Video upload failed. Please try again.';
        setTimeout(() => {
          this.$refs.videoRef.clearVideo();
        }, 2000);
      } finally {
        // Clean up the controller
        if (this.videoUploadController) {
          this.videoUploadController = null;
        }

        // Hide progress bar after delay (unless it was cancelled, which handles its own timeout)
        setTimeout(() => {
          if (this.videoUploadProgress.state !== 'cancelled') {
            this.videoUploadProgress.visible = false;
          }
        }, 2000);
      }
    },
  },
  computed: {
    canAccessAudienceFeatures() {
      return (
        Navigation.isAllowed('accessAudienceFeatures') ||
        Navigation.isAdmin() ||
        Navigation.isSuperAdmin()
      );
    },
    watchedAudienceValue() {
      let clientId = null;
      if (this.agency && this.agency.client && this.agency.client.id) {
        clientId = this.agency.client.id;
      }

      let agencyId = null;
      if (this.agency && this.agency.id) {
        agencyId = this.agency.id;
      }

      return {
        agentId: this.agentId,
        clientId,
        agencyId,
      };
    },
    propertyValue() {
      return this.properties
        ? this.properties.find((property) => {
            if (this.selectedProperty) {
              return property.id === this.selectedProperty.id;
            }
          })
        : null;
    },
    queryParams() {
      return JSON.stringify({
        id: this.agency.client.id,
        title: this.agency.client.title,
      });
    },
    watchedUrlValue() {
      return {
        urlSource: this.urlSource,
        property: this.selectedProperty,
        userId: this.selectedUserId,
        showPropertyUrlField:
          this.agency &&
          this.agency.client &&
          this.agency.client.clientDisplayConfig
            ? this.agency.client.clientDisplayConfig.showPropertyUrlField
            : false,
      };
    },
    officeLogoPreviewUrl() {
      if (
        !this.agency ||
        !this.agency.imageLogo ||
        !this.agency.imageLogo.location
      ) {
        return null;
      }

      return process.env.VUE_APP_CDN_URL + this.agency.imageLogo.location;
    },
  },
  mounted() {
    let today = new Date();
    this.tomorrow = new Date();
    this.tomorrow.setDate(today.getDate() + 1);
    let dd = String(this.tomorrow.getDate()).padStart(2, '0');
    let mm = String(this.tomorrow.getMonth() + 1).padStart(2, '0');
    let yyyy = this.tomorrow.getFullYear();
    this.tomorrow = yyyy + '-' + mm + '-' + dd;
    this.getAgency();
    this.user = this.$store.getters.getUser;
  },
  watch: {
    mainImageUpdated: {
      handler: function(val) {
        if (
          val &&
          this.$refs.mainImageRef &&
          typeof this.$refs.mainImageRef.uploadFile.size !== 'undefined'
        ) {
          this.uploadTemporaryFile();
        }
      },
    },
    watchedAudienceValue: {
      handler: function(value) {
        if (Object.values(value).every((val) => !val)) return;
        if (!this.canAccessAudienceFeatures) return;

        AudienceServiceV2.getScopedAudiences(value).then((response) => {
          const data = response.data.data;

          this.audiences = data || [];

          if (this.selectedAudience) {
            const selectedAudienceExists = this.audiences.find(
              (audience) => audience.id === this.selectedAudience.id
            );

            if (!selectedAudienceExists) {
              this.selectedAudience = null;
            }
          }
        });
      },
    },
    watchedUrlValue: {
      handler: function(value) {
        if (value.urlSource === 'property' && value.showPropertyUrlField) {
          this.url = this.campaign.propertyUrl
            ? this.campaign.propertyUrl
            : value.property.url;
          return;
        }

        if (value.urlSource === 'property' && !value.showPropertyUrlField) {
          this.url =
            value.property && value.property.url ? value.property.url : null;
          return;
        }

        this.url = '';
        const user = this.users.find((user) => user.id === value.userId);

        if (!user) return;
        this.url = user.destinationUrl;
      },
    },
    'campaign.propertyUrl': {
      handler: function(value) {
        const showPropertyUrlField =
          this.agency &&
          this.agency.client &&
          this.agency.client.clientDisplayConfig
            ? this.agency.client.clientDisplayConfig.showPropertyUrlField
            : false;

        if (this.urlSource === 'property' && showPropertyUrlField) {
          this.url = value;
        }
      },
    },
    selectedPackage: function(newPackage) {
      if (newPackage) {
        // Clear video URL when package changes
        this.campaign.videoId = null;
        this.video = null;
      }
    },
    // "agentCampaign.postcode": function (newVal, oldVal) {
    //   if (newVal && newVal.length <= 5) {
    //     let firstFourCharacters = newVal.slice(0, 4);
    //     this.agentCampaign.postcode = firstFourCharacters + ", ";
    //   }
    // },
  },
};
</script>

<style lang="css"></style>
